const donorDashboard = {
  year: 'Tax year',
  paidTotal: 'Total paid',
  taxDeductible: 'Tax-deductible paid',
  paymentsCount: '%count% payments',
  organisationsIncluded: '%included% of %total% organisations',
  scheduledTotal: 'Scheduled',
  scheduledBreakdown: 'Payments %payments% · Invoices %invoices%',
  scheduledHint: 'Scheduled payments plus invoice scheduled amounts.',
  unpaidPledges: 'Unpaid pledges',
  pledgesCount: '%count% pledges',
  downloadReceipts: 'Tax receipts (PDF)',
  downloadAll: 'Download all receipts',
  downloadAllStarted: 'Preparing tax receipts for all organisations…',
  downloadAllDone: 'Downloaded tax receipts for %count% organisation(s)',
  downloadAllPartial: 'Downloaded %downloaded% organisation(s); %skipped% had no receipts or failed',
  downloadAllNone: 'No tax receipts available for the selected year',
  organisationError: 'Could not load this organisation',
  partialError: 'Some figures could not be loaded',
  noActivity: 'No activity in %year%',
  retry: 'Retry',
  noOrganisations: 'No organisations connected',
  noOrganisationsHint: 'Connect to an organisation to see your donation summary.',
  loadError: 'Could not load the dashboard',
  partialTotalsWarning: 'Some organisations could not be loaded; totals exclude their data.',
};

export default donorDashboard;
